/// <reference types="jquery" />
/// <reference types="q" />

import Diag = require("VSS/Diag");
import { Constants, IMentionTextPart, MentionsRenderer } from "Mention/Scripts/TFS.Mention";

export interface IPullRequestMention {
    Anchor: JQuery;
    ArtifactId: string;
}

/**
 * Processes html with PR mentions and decorate links using PullRequestMentionsRenderer which fetches a PR by id
 * and renders with icon and current title.
 * It supports two different formats:
 * 1. current format: host/_git/repo/pullrequest/id data-vss-mention="version:1.0,id"
 * 2. legacy permalink: host/_permalink/_git/repo/pullrequest/id?collectionId=guid;projectId=guid data-vss-mention="version:1.0:pullrequest:collectionGuid:projectGuid:repoGuid:id
 */
export class PullRequestLinkProcessor {
    public static parseHtml($html: JQuery): IPullRequestMention[] {
        Diag.Debug.assertParamIsNotNull($html, "$html");
        const $prMentions = $html.find(
            `a[href*="/_git/"][href*="/pullrequest/"][${Constants.HTML_MENTION_ATTR_NAME}^="${Constants.HTML_MENTION_VERSION_10}"]` // this expression matches both current and permalink formats
        );

        const mentions: IPullRequestMention[] = [];

        $prMentions.each((i, elem) => {
            var $a = $(elem);
            const url = $a.attr("href");
            const segments = url.split("/");
            const prId = segments[segments.length - 1]; // prId may contain query parameters for legacy permalink
            const id = parseInt(prId, 10);
            if (id) {
                mentions.push({ ArtifactId: id.toString(), Anchor: $a });
            }
        });

        return mentions;
    }

    public static processHtml($html: JQuery) {
        const mentions: IPullRequestMention[] = this.parseHtml($html);
        mentions.forEach((prMention: IPullRequestMention) => {
            const $tempContainer = $("<span/>");
            const mention = {
                ArtifactId: prMention.ArtifactId,
                ArtifactType: "PullRequest"
            };

            MentionsRenderer.getDefault()
                .renderMention($tempContainer, mention as IMentionTextPart)
                .then((result) => {
                    if (result) {
                        prMention.Anchor.replaceWith(result.htmlComponent);
                    }
                });
        });
    }
}
